import { forwardRef, useCallback, useMemo, useState } from 'react'
import {
  ButtonGroup,
  Form,
  OverlayTrigger,
  Tooltip,
  Card,
  Badge as BSBadge,
  Row,
  Col,
  Container,
  Modal,
} from 'react-bootstrap'
import {
  CircleFill,
  Coin,
  Diagram3Fill,
  PrinterFill,
  Upload,
  CheckCircleFill,
  XCircleFill,
  Search,
  Check2Square,
  ClockHistory,
  ListNested,
  CardList,
  PlusCircleFill,
} from 'react-bootstrap-icons'
import Dropdown from 'react-bootstrap/Dropdown'
import Table from 'react-bootstrap/Table'
import { BsPencil, BsShare, BsTrash } from 'react-icons/bs'
import {
  FaClone,
  FaCube,
  FaCubes,
  FaDashcube,
  FaFilter,
  FaFileDownload,
  FaBox,
} from 'react-icons/fa'
import { MdPriceCheck } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom'
import { useProducts } from '../../hooks/useProducts'
import { CustomButton } from '../CustomButton'
import { ModalEnviarOfertasLeroy } from './ModalEnviarOfertasLeroy'

import './listaproduto.css'

import { Eye, EyeSlash } from '@phosphor-icons/react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { toast } from 'react-toastify'
import { useOrdenation } from '../../hooks/useOrdenation'
import apinode from '../../services/apinode'
import { formatPrice } from '../../utils/formatPrice'
import { getValue } from '../../utils/getValue'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { Ask } from '../Ask'
import { CustomSpinner } from '../CustomSpinner'
import { ModalConsultarHeranca } from './ModalConsultarHeranca'
import { ModalEditarPrecos } from './ModalEditarPrecos'
import { formatDate } from '../../utils/formatDate'
import { ModalConsultarComposicao } from './ModalConsultarComposicao'
import { ModalConsultarUnitarioKits } from './ModalConsultarUnitarioKits'

const ListaProdutos = forwardRef((props, ref) => {
  const [tipoFiltro, setTipoFiltro] = useState('')
  const [isModalEnviarOfertasOpen, setIsModalEnviarOfertasOpen] =
    useState(false)
  const [isModalEditarPrecosOpen, setIsModalEditarPrecosOpen] = useState(false)
  const [loading, setIsLoading] = useState(false)
  const [isPrintRequestLoading, setIsPrintRequestLoading] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState({})
  const [isStockMatrizLoading, setIsStockMatrizLoading] = useState({})
  const [stockMatriz, setStockMatriz] = useState(null)
  const [isStockInfoOpen, setIsStockInfoOpen] = useState({})
  const [hierarchy, setHierarchy] = useState({})
  const [isConsultarHerancaLoading, setIsConsultarHerancaLoading] = useState({})
  const [isConsultarComposicaoLoading, setIsConsultarComposicaoLoading] =
    useState({})
  const [isConsultarUnitarioKitsLoading, setIsConsultarUnitarioKitsLoading] =
    useState({})
  const [isModalConsultarHerancaOpen, setIsModalConsultarHerancaOpen] =
    useState(false)
  const [modalConsultarComposicao, setModalConsultarComposicao] = useState({
    isOpen: false,
    data: null,
  })
  const [modalConsultarUnitarioKits, setModalConsultarUnitarioKits] = useState({
    isOpen: false,
    data: null,
  })
  const [statusLocal, setStatusLocal] = useState({})
  const [isGettingLogPrices, setIsGettingLogPrices] = useState({})
  const [logPrices, setLogPrices] = useState([])
  const [isModalPricesOpen, setIsModalLogPricesOpen] = useState(false)
  const [isMoreActionsOpen, setIsMoreActionsOpen] = useState({})

  const navigate = useNavigate()

  const { productsToExport, setProductsToExport } = useProducts()

  const getStatus = (produto) => {
    const sku = produto?.SKU
    return statusLocal[sku] ?? produto.HABILITADO_VENDA ?? 'S'
  }

  const alterarStatusProduto = async (sku) => {
    try {
      const response = await apinode.put(
        `/estoque/alteracao/${localStorage.idconta}`,
        { sku },
      )

      toast.success(response.data.message)
      return response.data
    } catch (error) {
      console.error('Erro ao alterar produto:', error)
      toast.error('Erro ao alterar produto.')
      throw error
    }
  }

  pdfMake.addVirtualFileSystem(pdfFonts)

  async function getLogPricesUpdate(sku, index) {
    try {
      setIsGettingLogPrices((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode.get(
        `/prices/update-logs/${sku}/${localStorage.idconta}`,
      )

      setLogPrices(response.data)
      setIsModalLogPricesOpen(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar histórico de preços')
    } finally {
      setIsGettingLogPrices((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  const generatePDF = async (data) => {
    setIsLoading(true)
    const isAdmin = localStorage.admin === 'SIM'
    const currentDateTime = new Date().toLocaleString('pt-BR')
    const currentUser = localStorage.username

    const docDefinition = {
      footer: function (currentPage, pageCount) {
        return {
          text: `Página ${currentPage.toString()} de ${pageCount.toString()}`,
          alignment: 'center',
        }
      },
      content: [
        { text: 'Lista de Produtos', style: 'header' },
        {
          text: `Data e Hora da Impressão: ${currentDateTime}`,
          fontSize: 8,
          margin: [0, 0, 0, 5],
        },
        { text: `Usuário: ${currentUser}`, fontSize: 8, margin: [0, 0, 0, 5] },
        {
          table: {
            headerRows: 1,
            widths: [50, 150, 70, 70, 60, 60, 60, 60, 60],
            body: [
              [
                'SKU',
                'Descrição',
                'Preço Venda',
                ...(isAdmin ? ['Custo'] : []),
                'Reservado',
                'Saldo',
              ],
              ...data.map((produto) => [
                { text: produto.SKU, fontSize: 8 },
                { text: produto.DESCRICAO, fontSize: 8 },
                {
                  text: `R$ ${parseFloat(produto.PRECOVENDA).toFixed(2).replace('.', ',')}`,
                  fontSize: 8,
                },
                ...(isAdmin
                  ? [
                      {
                        text: `R$ ${parseFloat(produto.PRECOCUSTO || 0)
                          .toFixed(2)
                          .replace('.', ',')}`,
                        fontSize: 8,
                      },
                    ]
                  : []),
                { text: produto.QTRESERV, fontSize: 8 },
                { text: produto.QTEST, fontSize: 8 },
              ]),
            ],
            style: 'tableStyle',
            layout: {
              defaultBorder: false,
            },
          },
        },
      ],
      styles: {
        header: {
          fontSize: 10,
          bold: true,
          margin: [0, 0, 0, 5],
        },
        tableStyle: {
          border: 'none',
          fontSize: 8,
        },
      },
    }

    try {
      const pdf = pdfMake.createPdf(docDefinition)
      pdf.open()
    } finally {
      setIsLoading(false)
    }
  }

  const filteredProdutos = useMemo(() => {
    let data = props.arrayClientes

    if (tipoFiltro) {
      data = data.filter((cliente) => cliente.UNIDADE === tipoFiltro)
    }

    return data
  }, [props.arrayClientes, tipoFiltro])

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(filteredProdutos, 'SKU')

  const {
    filteredItems: filteredPrices,
    Th: ThPrice,
    Paginate: PaginatePrice,
  } = useOrdenation(logPrices, 'data_alteracao')

  const mediaPrecoCustoAntigo =
    filteredPrices.reduce((acc, item) => {
      acc = acc + item.precocusto_old

      return acc
    }, 0) / filteredPrices.filter((price) => price.precocusto_old !== 0).length

  const mediaPrecoCustoNovo =
    filteredPrices.reduce((acc, item) => {
      acc = acc + item.precocusto_new

      return acc
    }, 0) / filteredPrices.filter((price) => price.precocusto_new !== 0).length

  const mediaPrecoVendaAntigo =
    filteredPrices.reduce((acc, item) => {
      acc = acc + item.precovenda_old

      return acc
    }, 0) / filteredPrices.filter((price) => price.precovenda_old !== 0).length

  const mediaPrecoVendaNovo =
    filteredPrices.reduce((acc, item) => {
      acc = acc + item.precovenda_new

      return acc
    }, 0) / filteredPrices.filter((price) => price.precovenda_new !== 0).length

  const itemsPerPageOptions = [10, 25, 50, 100]
  const tipoFiltroOptions = ['', 'UN', 'KIT', 'PC']

  const totalCusto = useMemo(() => {
    const data = filteredProdutos.reduce((acc, item) => {
      acc = acc + item.PRECOCUSTO
      return acc
    }, 0)
    return formatPrice(data)
  }, [filteredProdutos])

  const totalVenda = useMemo(() => {
    const data = filteredProdutos.reduce((acc, item) => {
      acc = acc + item.PRECOVENDA
      return acc
    }, 0)
    return formatPrice(data)
  }, [filteredProdutos])

  const totalEstoque = useMemo(() => {
    const data = filteredProdutos.reduce((acc, item) => {
      if (item.QTESTGER > 0) {
        acc = acc + item.QTESTGER * item.PRECOCUSTO
      }
      return acc
    }, 0)
    return formatPrice(data)
  }, [filteredProdutos])

  async function consultarHeranca(sku, index) {
    setHierarchy({})

    try {
      setIsConsultarHerancaLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode.get(
        `/consultar_heranca/${localStorage.idconta}?search=${sku}`,
      )

      if (response.data?.children.length === 0 && !response.data?.dad) {
        return toast.warn('Este produto não está associado à nenhum outro')
      }

      setHierarchy(response.data)
      setIsModalConsultarHerancaOpen(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao consultar herança')
    } finally {
      setIsConsultarHerancaLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function consultarComposicao(sku, index) {
    try {
      setIsConsultarComposicaoLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode.get(
        `/consultar_composicao/${sku}/${localStorage.idconta}`,
      )

      setModalConsultarComposicao({
        isOpen: true,
        data: response.data,
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao consultar composição')
    } finally {
      setIsConsultarComposicaoLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function consultarUnitariosKit(sku, index) {
    try {
      setIsConsultarUnitarioKitsLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode.get(
        `/consultar_unitarios_kit/${sku}/${localStorage.idconta}`,
      )

      setModalConsultarUnitarioKits({
        isOpen: true,
        data: response.data,
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao consultar unitário em kits')
    } finally {
      setIsConsultarUnitarioKitsLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function handlePrintLabel(product) {
    try {
      setIsPrintRequestLoading(true)

      await apinode.post(`/produtos/print-label/${localStorage.idconta}`, {
        sku: product.SKU,
        descricao: product.DESCRICAO,
      })

      toast.success(
        'Este produto foi enviado á uma fila. Logo ele será impresso!',
      )
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível imprimir o SKU!')
    } finally {
      setIsPrintRequestLoading(false)
    }
  }

  function handleOpenModalEditarPrecos(product) {
    setSelectedProduct(product)
    setIsModalEditarPrecosOpen(true)
  }

  const handleSelectProduct = useCallback(
    (e, product) => {
      if (e.target.checked) {
        setProductsToExport((prevState) => [...prevState, product])
      } else {
        setProductsToExport((prevState) =>
          prevState.filter((prod) => prod !== product),
        )
      }
    },
    [setProductsToExport],
  )

  async function handleGetStockMatriz(sku, index) {
    try {
      setIsStockMatrizLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode(
        `/estoque/produto/${process.env.REACT_APP_DATABASE_MATRIZ}/${sku}`,
      )

      if (!response.data.exists) {
        return toast.warn('Produto não foi encontrado na matriz')
      }

      setStockMatriz(response.data.stock || 0)
      setIsStockInfoOpen({
        [index]: true,
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar o estoque na matriz')
    } finally {
      setIsStockMatrizLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  return (
    <>
      {props.isLoadingProduct ? (
        <Container
          fluid
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '60vh' }}
        >
          <CustomSpinner />
        </Container>
      ) : (
        <div ref={ref}>
          {/* Header moderno */}

          {props.isSectionVisible && (
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body className="p-4">
                {/* Filtros e Controles */}
                <Row className="g-3">
                  <Col md={3}>
                    <Form.Label className="text-muted small mb-1">
                      <FaFilter className="me-2" />
                      Itens por Página
                    </Form.Label>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="outline-secondary"
                        className="w-100 text-start"
                      >
                        {itemsPerPage} itens
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {itemsPerPageOptions.map((option) => (
                          <Dropdown.Item
                            key={option}
                            onClick={() => setItemsPerPage(option)}
                            active={itemsPerPage === option}
                          >
                            {option} itens
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>

                  <Col md={3}>
                    <Form.Label className="text-muted small mb-1">
                      <FaFilter className="me-2" />
                      Tipo de Produto
                    </Form.Label>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="outline-secondary"
                        className="w-100 text-start"
                      >
                        {tipoFiltro || 'Todos os tipos'}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {tipoFiltroOptions.map((option) => (
                          <Dropdown.Item
                            key={option}
                            onClick={() => setTipoFiltro(option)}
                            active={tipoFiltro === option}
                          >
                            {option || 'Todos'}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>

                  <Col
                    md={6}
                    className="d-flex align-items-end"
                  >
                    <div className="w-100">
                      <BSBadge
                        bg="primary"
                        className="px-3 py-2 me-2"
                      >
                        <Search className="me-2" />
                        {new Intl.NumberFormat('pt-BR').format(
                          filteredProdutos.length,
                        )}{' '}
                        produtos
                      </BSBadge>
                      <BSBadge
                        bg="success"
                        className="px-3 py-2"
                      >
                        <FaBox className="me-2" />
                        Exibindo {filteredItems.length}
                      </BSBadge>
                    </div>
                  </Col>
                </Row>

                {/* Cards de Totais - Admin */}
                {localStorage.admin === 'SIM' && (
                  <Row className="mt-4 g-3">
                    <Col md={4}>
                      <Card className="border-0 bg-warning bg-opacity-10 h-100">
                        <Card.Body className="d-flex align-items-center">
                          <CircleFill
                            className="text-warning me-3"
                            size={24}
                          />
                          <div>
                            <small className="text-muted d-block">
                              Total Custo
                            </small>
                            <h5 className="mb-0 fw-bold">{totalCusto}</h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card className="border-0 bg-success bg-opacity-10 h-100">
                        <Card.Body className="d-flex align-items-center">
                          <CircleFill
                            className="text-success me-3"
                            size={24}
                          />
                          <div>
                            <small className="text-muted d-block">
                              Total Venda
                            </small>
                            <h5 className="mb-0 fw-bold">{totalVenda}</h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card className="border-0 bg-primary bg-opacity-10 h-100">
                        <Card.Body className="d-flex align-items-center">
                          <CircleFill
                            className="text-primary me-3"
                            size={24}
                          />
                          <div>
                            <small className="text-muted d-block">
                              Total Estoque
                            </small>
                            <h5 className="mb-0 fw-bold">{totalEstoque}</h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                )}
              </Card.Body>
            </Card>
          )}

          {/* Tabela de Produtos */}
          <Card className="shadow-sm border-0">
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table
                  hover
                  className="mb-0"
                  id="table-to-xls"
                >
                  <thead className="bg-light">
                    <tr>
                      <th colSpan="14">
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                          }}
                        >
                          <CustomButton
                            noMargin
                            title="Selecionar/Desmarcar Todos"
                            onClick={() => {
                              if (productsToExport.length > 0) {
                                setProductsToExport([])
                              } else {
                                for (const item of filteredProdutos) {
                                  setProductsToExport((prevState) => [
                                    ...prevState,
                                    item,
                                  ])
                                }
                              }
                            }}
                          >
                            <Check2Square />
                          </CustomButton>

                          <p
                            style={{
                              all: 'unset',
                              fontSize: 16,
                            }}
                          >
                            {productsToExport.length} produtos selecionados de{' '}
                            {filteredProdutos.length}
                          </p>
                        </div>
                      </th>
                    </tr>

                    <tr>
                      <th style={{ fontSize: '12px', fontWeight: '600' }}>
                        <Form.Check
                          inline
                          type="checkbox"
                          checked={filteredItems.every((prod) =>
                            Boolean(
                              productsToExport.find((p) => p.SKU == prod.SKU)
                                ?.SKU,
                            ),
                          )}
                          onChange={(e) => {
                            for (const item of filteredItems) {
                              if (e.target.checked) {
                                const index = productsToExport.findIndex(
                                  (prod) => prod.SKU == item.SKU,
                                )

                                if (index === -1) {
                                  setProductsToExport((prevState) => [
                                    ...prevState,
                                    item,
                                  ])
                                }
                              } else {
                                setProductsToExport((prevState) =>
                                  prevState.filter(
                                    (prod) => prod.SKU != item.SKU,
                                  ),
                                )
                              }
                            }
                          }}
                        />
                      </th>
                      <th style={{ fontSize: '12px', fontWeight: '600' }}>
                        Imagem
                      </th>
                      <Th
                        label="SKU"
                        value="SKU"
                        style={{ fontSize: '12px', fontWeight: '600' }}
                      />
                      <Th
                        label="Descrição"
                        value="DESCRICAO"
                        style={{ fontSize: '12px', fontWeight: '600' }}
                      />
                      <th style={{ fontSize: '12px', fontWeight: '600' }}>
                        EAN
                      </th>
                      <th style={{ fontSize: '12px', fontWeight: '600' }}>
                        NCM
                      </th>
                      <Th
                        label="Preço Custo"
                        value="PRECOCUSTO"
                        style={{ fontSize: '12px', fontWeight: '600' }}
                      />
                      <Th
                        label="Preço Venda"
                        value="PRECOVENDA"
                        style={{ fontSize: '12px', fontWeight: '600' }}
                      />
                      <Th
                        label="Estoque"
                        value="QTESTGER"
                        style={{ fontSize: '12px', fontWeight: '600' }}
                      />
                      <th style={{ fontSize: '12px', fontWeight: '600' }}>
                        Reservado
                      </th>
                      <th style={{ fontSize: '12px', fontWeight: '600' }}>
                        Saldo
                      </th>
                      <th style={{ fontSize: '12px', fontWeight: '600' }}>
                        Matriz
                      </th>
                      <th style={{ fontSize: '12px', fontWeight: '600' }}>
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredItems.length > 0 ? (
                      filteredItems.map((produto, index) => (
                        <>
                          <tr
                            key={produto.CODPRODUTO}
                            className="align-middle"
                          >
                            <td>
                              <Form.Check
                                checked={productsToExport.includes(produto)}
                                type="checkbox"
                                inline
                                onChange={(e) =>
                                  handleSelectProduct(e, produto)
                                }
                              />
                            </td>

                            <td>
                              <a
                                href={`${process.env.REACT_APP_BACKEND_API}/imagens/${produto.IMG_CAPA || 'no-image.jpg'}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={`${process.env.REACT_APP_BACKEND_API}/imagens/${produto.IMG_CAPA || 'no-image.jpg'}`}
                                  style={{
                                    width: '60px',
                                    height: '45px',
                                    objectFit: 'cover',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    border: '1px solid #dee2e6',
                                  }}
                                  alt={produto.DESCRICAO}
                                />
                              </a>
                            </td>

                            <td style={{ fontSize: '12px' }}>
                              <span className="fw-semibold">{produto.SKU}</span>
                            </td>

                            <td style={{ fontSize: '12px' }}>
                              <div className="mb-1">
                                {getStatus(produto) === 'N' ? (
                                  <BSBadge
                                    bg="danger"
                                    className="me-2"
                                  >
                                    Desabilitado
                                  </BSBadge>
                                ) : null}
                                {produto.DESCRICAO}
                              </div>
                              <div>
                                {produto.FORMATO === 'S' ? (
                                  <BSBadge
                                    bg="primary"
                                    className="me-1"
                                  >
                                    Simples
                                  </BSBadge>
                                ) : produto.FORMATO === 'C' ? (
                                  <BSBadge bg="success">Composição</BSBadge>
                                ) : null}
                              </div>
                            </td>

                            <td style={{ fontSize: '12px' }}>
                              {produto?.GTIN ? (
                                <BSBadge bg="secondary">{produto.GTIN}</BSBadge>
                              ) : (
                                <span className="text-muted">-</span>
                              )}
                            </td>

                            <td style={{ fontSize: '12px' }}>
                              {getValue(produto?.CODNCM)}
                            </td>

                            {localStorage.admin === 'SIM' ? (
                              <td style={{ fontSize: '12px' }}>
                                <span className="text-success fw-semibold">
                                  R${' '}
                                  {produto.PRECOCUSTO
                                    ? produto.PRECOCUSTO.toFixed(2).replace(
                                        '.',
                                        ',',
                                      )
                                    : '0,00'}
                                </span>
                              </td>
                            ) : (
                              <td style={{ fontSize: '12px' }}>-</td>
                            )}

                            <td style={{ fontSize: '12px' }}>
                              <span className="text-primary fw-semibold">
                                R${' '}
                                {produto.PRECOVENDA
                                  ? produto.PRECOVENDA.toFixed(2).replace(
                                      '.',
                                      ',',
                                    )
                                  : '0,00'}
                              </span>
                            </td>

                            <td style={{ fontSize: '12px' }}>
                              <BSBadge
                                bg={produto.QTESTGER > 0 ? 'success' : 'danger'}
                              >
                                {produto.QTESTGER
                                  ? produto.QTESTGER.toFixed(2)
                                  : '0.00'}
                              </BSBadge>
                            </td>

                            <td style={{ fontSize: '12px' }}>
                              {produto.QTRESERV
                                ? produto.QTRESERV.toFixed(2)
                                : '0.00'}
                            </td>

                            <td style={{ fontSize: '12px' }}>
                              <BSBadge
                                bg={produto.QTEST > 0 ? 'info' : 'secondary'}
                              >
                                {produto.QTEST
                                  ? produto.QTEST.toFixed(2)
                                  : '0.00'}
                              </BSBadge>
                            </td>

                            <td style={{ fontSize: '12px' }}>
                              <OverlayTrigger
                                overlay={
                                  <Tooltip>
                                    {isStockInfoOpen[index]
                                      ? 'Ocultar Estoque'
                                      : 'Buscar Estoque'}
                                  </Tooltip>
                                }
                              >
                                <CustomButton
                                  isLoading={isStockMatrizLoading[index]}
                                  isDisabled={!produto.SKU}
                                  onClick={() =>
                                    isStockInfoOpen[index]
                                      ? setIsStockInfoOpen({ [index]: false })
                                      : handleGetStockMatriz(produto.SKU, index)
                                  }
                                >
                                  {isStockInfoOpen[index] ? (
                                    <EyeSlash weight="fill" />
                                  ) : (
                                    <Eye weight="fill" />
                                  )}
                                </CustomButton>
                              </OverlayTrigger>

                              {isStockInfoOpen[index] &&
                                getValue(stockMatriz) && (
                                  <div
                                    className="mt-2"
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <small className="text-muted">
                                      Est: {Number(stockMatriz).toFixed(2)}
                                    </small>
                                  </div>
                                )}
                            </td>

                            <td>
                              <ButtonGroup size="sm">
                                <OverlayTrigger
                                  overlay={<Tooltip>Mais Ações</Tooltip>}
                                >
                                  <CustomButton
                                    color="#2D936C"
                                    onClick={() =>
                                      isMoreActionsOpen[index]
                                        ? setIsMoreActionsOpen({})
                                        : setIsMoreActionsOpen({
                                            [index]: true,
                                          })
                                    }
                                  >
                                    <PlusCircleFill />
                                  </CustomButton>
                                </OverlayTrigger>
                              </ButtonGroup>
                            </td>
                          </tr>

                          {isMoreActionsOpen[index] && (
                            <tr>
                              <td colSpan={13}>
                                <div
                                  style={{
                                    minWidth: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <ButtonGroup size="sm">
                                    <OverlayTrigger
                                      overlay={<Tooltip>Editar</Tooltip>}
                                    >
                                      <button className="btn btn-warning btn-sm">
                                        <Link
                                          to={`/produtos/${produto.CODPRODUTO}`}
                                          target="_blank"
                                        >
                                          <BsPencil />
                                        </Link>
                                      </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip>Consultar Herança</Tooltip>
                                      }
                                    >
                                      <CustomButton
                                        color="#2D936C"
                                        onClick={() =>
                                          consultarHeranca(produto.SKU, index)
                                        }
                                        isLoading={
                                          isConsultarHerancaLoading[index]
                                        }
                                      >
                                        <Diagram3Fill />
                                      </CustomButton>
                                    </OverlayTrigger>

                                    {produto.UNIDADE === 'KIT' && (
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            Consultar Composição de Kit
                                          </Tooltip>
                                        }
                                      >
                                        <CustomButton
                                          color="#0C6291"
                                          onClick={() =>
                                            consultarComposicao(
                                              produto.SKU,
                                              index,
                                            )
                                          }
                                          isLoading={
                                            isConsultarComposicaoLoading[index]
                                          }
                                        >
                                          <ListNested />
                                        </CustomButton>
                                      </OverlayTrigger>
                                    )}

                                    {produto.UNIDADE === 'UN' && (
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            Consultar Unitário em Kits
                                          </Tooltip>
                                        }
                                      >
                                        <CustomButton
                                          color="#DB324D"
                                          onClick={() =>
                                            consultarUnitariosKit(
                                              produto.SKU,
                                              index,
                                            )
                                          }
                                          isLoading={
                                            isConsultarUnitarioKitsLoading[
                                              index
                                            ]
                                          }
                                        >
                                          <CardList />
                                        </CustomButton>
                                      </OverlayTrigger>
                                    )}

                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip>Habilitar/Desabilitar</Tooltip>
                                      }
                                    >
                                      <CustomButton
                                        onClick={async () => {
                                          const sku = produto.SKU
                                          setStatusLocal((prev) => {
                                            const atual =
                                              prev[sku] ??
                                              produto.HABILITADO_VENDA ??
                                              'S'
                                            const novo =
                                              atual === 'S' ? 'N' : 'S'
                                            return { ...prev, [sku]: novo }
                                          })

                                          try {
                                            const data =
                                              await alterarStatusProduto(sku)
                                            const confirmado =
                                              data?.produto?.para
                                            if (
                                              confirmado === 'S' ||
                                              confirmado === 'N'
                                            ) {
                                              setStatusLocal((prev) => ({
                                                ...prev,
                                                [sku]: confirmado,
                                              }))
                                            }
                                          } catch (error) {
                                            setStatusLocal((prev) => {
                                              const atual =
                                                prev[sku] ??
                                                produto.HABILITADO_VENDA ??
                                                'S'
                                              const revertido =
                                                atual === 'S' ? 'N' : 'S'
                                              return {
                                                ...prev,
                                                [sku]: revertido,
                                              }
                                            })
                                          }
                                          setSelectedProduct(produto)
                                        }}
                                      >
                                        {getStatus(produto) === 'S' ? (
                                          <CheckCircleFill
                                            size={18}
                                            color="white"
                                          />
                                        ) : (
                                          <XCircleFill
                                            size={18}
                                            color="white"
                                          />
                                        )}
                                      </CustomButton>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip>
                                          Enviar Oferta Leroy Merlin
                                        </Tooltip>
                                      }
                                    >
                                      <CustomButton
                                        color="#1e8449"
                                        onClick={() => {
                                          setSelectedProduct(produto)
                                          setIsModalEnviarOfertasOpen(true)
                                        }}
                                      >
                                        <Upload />
                                      </CustomButton>
                                    </OverlayTrigger>

                                    {localStorage.admin === 'SIM' && (
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            Ver Histórico de Alterações de
                                            Preços
                                          </Tooltip>
                                        }
                                      >
                                        <CustomButton
                                          color="#EF2D56"
                                          isLoading={isGettingLogPrices[index]}
                                          onClick={() =>
                                            getLogPricesUpdate(
                                              produto.SKU,
                                              index,
                                            )
                                          }
                                        >
                                          <ClockHistory />
                                        </CustomButton>
                                      </OverlayTrigger>
                                    )}

                                    {localStorage.admin === 'SIM' && (
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            Cálculo Real dos Lucros
                                          </Tooltip>
                                        }
                                      >
                                        <CustomButton
                                          color="#F54927"
                                          onClick={() => {
                                            Ask(
                                              'Deseja ir para Cálculo Real Dos Lucros?',
                                              () =>
                                                navigate(
                                                  '/mercadolivre/calculo-lucros',
                                                  {
                                                    state: {
                                                      codproduto:
                                                        produto.CODPRODUTO,
                                                      sku: produto.SKU,
                                                      descricao:
                                                        produto.DESCRICAO,
                                                      precocusto:
                                                        produto.PRECOCUSTO,
                                                      precovenda:
                                                        produto.PRECOVENDA,
                                                    },
                                                  },
                                                ),
                                            )
                                          }}
                                        >
                                          <Coin />
                                        </CustomButton>
                                      </OverlayTrigger>
                                    )}

                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip>Imprimir Etiqueta</Tooltip>
                                      }
                                    >
                                      <CustomButton
                                        color="#510e6c"
                                        onClick={() =>
                                          handlePrintLabel(produto)
                                        }
                                        isLoading={isPrintRequestLoading}
                                      >
                                        <PrinterFill />
                                      </CustomButton>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={<Tooltip>Editar Preços</Tooltip>}
                                    >
                                      <button
                                        className="btn btn-sm"
                                        style={{ backgroundColor: '#005d27' }}
                                        onClick={() =>
                                          handleOpenModalEditarPrecos(produto)
                                        }
                                      >
                                        <MdPriceCheck
                                          color="white"
                                          size={15}
                                        />
                                      </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={<Tooltip>Deletar</Tooltip>}
                                    >
                                      <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() =>
                                          Ask('Deseja deletar o produto?', () =>
                                            props.clickDelete(
                                              produto.CODPRODUTO,
                                            ),
                                          )
                                        }
                                        disabled={localStorage.admin !== 'SIM'}
                                      >
                                        <BsTrash />
                                      </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={<Tooltip>Exportar</Tooltip>}
                                    >
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                          props.clickExport(
                                            produto.SKU,
                                            produto.PRECOVENDA,
                                            produto.DESCRICAO,
                                          )
                                        }
                                      >
                                        <BsShare />
                                      </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip>Manutenção de Estoque</Tooltip>
                                      }
                                    >
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                          props.clickAjustStock(produto.SKU)
                                        }
                                      >
                                        <FaCubes />
                                      </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={<Tooltip>Movimentações</Tooltip>}
                                    >
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                          props.clickMovProd(
                                            produto.SKU,
                                            produto.DESCRICAO,
                                          )
                                        }
                                      >
                                        <FaCube />
                                      </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={<Tooltip>Clonar</Tooltip>}
                                    >
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                          props.clickClonar(produto.SKU)
                                        }
                                      >
                                        <FaClone />
                                      </button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip>
                                          Ver Produtos filhos com custo médio
                                        </Tooltip>
                                      }
                                    >
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                          props.clickComposicao(produto.SKU)
                                        }
                                      >
                                        <FaDashcube />
                                      </button>
                                    </OverlayTrigger>
                                  </ButtonGroup>
                                </div>
                              </td>
                            </tr>
                          )}
                        </>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="15"
                          className="text-center py-5"
                        >
                          <FaBox
                            size={48}
                            className="text-muted mb-3"
                          />
                          <p className="text-muted mb-0">
                            Nenhum produto encontrado
                          </p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>

            <Card.Footer className="bg-light border-0 p-3">
              <div className="d-flex justify-content-between align-items-center">
                <button
                  onClick={() => {
                    setIsLoading(true)
                    generatePDF(props.arrayClientes)
                  }}
                  className="btn btn-primary d-flex align-items-center"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      />
                      Gerando...
                    </>
                  ) : (
                    <>
                      <FaFileDownload className="me-2" />
                      Gerar PDF
                    </>
                  )}
                </button>

                <Paginate />
              </div>
            </Card.Footer>
          </Card>
        </div>
      )}

      {isModalPricesOpen && (
        <Modal
          show={isModalPricesOpen}
          onHide={() => setIsModalLogPricesOpen(false)}
          centered
          dialogClassName="custom-modalzpl"
        >
          <Modal.Header>
            <Modal.Title>Log de alterações de preços</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Table
              striped
              bordered
              hover
            >
              <thead>
                <tr>
                  <ThPrice
                    label="Preço Custo Antigo"
                    value="precocusto_old"
                  />
                  <ThPrice
                    label="Preço Custo Novo"
                    value="precocusto_new"
                  />
                  <ThPrice
                    label="Preço Venda Antigo"
                    value="precovenda_old"
                  />
                  <ThPrice
                    label="Preço Venda Novo"
                    value="precovenda_new"
                  />
                  <ThPrice
                    label="Data de Alteração"
                    value="data_alteracao"
                  />
                </tr>
              </thead>

              <tbody>
                {filteredPrices.map((price) => (
                  <tr>
                    <td>{formatPrice(price.precocusto_old)}</td>
                    <td>{formatPrice(price.precocusto_new)}</td>
                    <td>{formatPrice(price.precovenda_old)}</td>
                    <td>{formatPrice(price.precovenda_new)}</td>
                    <td>{formatDate(price.data_alteracao)}</td>
                  </tr>
                ))}

                <tr>
                  <td>
                    <p style={{ all: 'unset' }}>
                      Média: {formatPrice(mediaPrecoCustoAntigo)}
                    </p>
                  </td>

                  <td>
                    <p style={{ all: 'unset' }}>
                      Média: {formatPrice(mediaPrecoCustoNovo)}
                    </p>
                  </td>

                  <td>
                    <p style={{ all: 'unset' }}>
                      Média: {formatPrice(mediaPrecoVendaAntigo)}
                    </p>
                  </td>

                  <td>
                    <p style={{ all: 'unset' }}>
                      Média: {formatPrice(mediaPrecoVendaNovo)}
                    </p>
                  </td>
                </tr>
              </tbody>
            </Table>

            <PaginatePrice />
          </Modal.Body>
        </Modal>
      )}

      {isModalEnviarOfertasOpen && (
        <ModalEnviarOfertasLeroy
          product={selectedProduct}
          isOpen={isModalEnviarOfertasOpen}
          onClose={() => setIsModalEnviarOfertasOpen(false)}
        />
      )}

      {isModalEditarPrecosOpen && (
        <ModalEditarPrecos
          productData={selectedProduct}
          isOpen={isModalEditarPrecosOpen}
          onClose={() => setIsModalEditarPrecosOpen(false)}
        />
      )}

      {isModalConsultarHerancaOpen && (
        <ModalConsultarHeranca
          isOpen={isModalConsultarHerancaOpen}
          onClose={() => setIsModalConsultarHerancaOpen(false)}
          dad={hierarchy.dad}
          kids={hierarchy.children}
        />
      )}

      {modalConsultarComposicao.isOpen && (
        <ModalConsultarComposicao
          isOpen={modalConsultarComposicao.isOpen}
          data={modalConsultarComposicao.data}
          onClose={() =>
            setModalConsultarComposicao({
              isOpen: false,
              data: null,
            })
          }
        />
      )}

      {modalConsultarUnitarioKits.isOpen && (
        <ModalConsultarUnitarioKits
          isOpen={modalConsultarUnitarioKits.isOpen}
          data={modalConsultarUnitarioKits.data}
          onClose={() =>
            setModalConsultarUnitarioKits({
              isOpen: false,
              data: null,
            })
          }
        />
      )}
    </>
  )
})

export default ListaProdutos
